import { useQuery } from '@apollo/client';
import { useMe } from '@crehana/web';
import { useRouter } from 'next/router';

import GetIsLeaderQuery from './graphql/GetIsLeader.v4.b2b.graphql';
import type {
  GetIsLeader,
  GetIsLeaderVariables,
} from './graphql/types/GetIsLeader';

const ROLE_MEMBER = 'member';

const useLeadership = () => {
  const { asPath, query } = useRouter();
  const { me } = useMe();

  const { slug, teamId } = query as { slug: string; teamId: string };

  const isLeaderPanel = asPath.includes('/lider/');
  const hiddenTeamSelect = asPath.includes('/lider/miembro/');

  const isStudent = me?.organization?.myRole === ROLE_MEMBER;

  const { data, loading } = useQuery<GetIsLeader, GetIsLeaderVariables>(
    GetIsLeaderQuery,
    {
      context: { clientName: 'v4.b2b' },
      notifyOnNetworkStatusChange: true,
      skip: !me?.originalId || !me?.username || !slug,
      variables: {
        userId: (me?.originalId || '').toString(),
        username: me?.username,
        organizationSlug: slug,
      },
    },
  );

  const isLeader = data?.organizationUserCurrent?.isLead || false;

  return {
    isLeader,
    isLeaderPanel,
    isLoadingLeader: loading,
    isStudent,
    hiddenTeamSelect,
    teamId,
  };
};

export default useLeadership;
